import { Accounting } from '~/types/accounting';
import { BillingTriggerType } from '~/types/api.model';
import * as serviceSelectors from '../service/selectors';
import { extendedRecurrencePeriodText } from '../service-billing/selectors';
import * as serviceCostPricing from '../service-cost/pricing';
import * as serviceTemplateBundleSelectors from '../service-template-bundle/selectors';
import { ServiceTemplateStatus } from './model';
export function isDeleted(serviceTemplate) {
    return serviceTemplate.status === ServiceTemplateStatus.Deleted;
}
export const integratedId = (param)=>{
    let { serviceTemplate, accounting } = param;
    switch(accounting){
        case Accounting.QBO:
            return serviceTemplate.integrations.qboIntegratedId();
        case Accounting.Xero:
            return serviceTemplate.integrations.xeroIntegratedId();
    }
};
export const isRangePrice = serviceCostPricing.isRangePrice;
export const isFixedPrice = serviceCostPricing.isFixedPrice;
export const isVariablePrice = serviceCostPricing.isVariablePrice;
export const discount = serviceSelectors.discount;
export const price = serviceSelectors.price;
export function unitName(serviceTemplate) {
    return serviceSelectors.unitName({
        cost: serviceTemplate.cost
    });
}
export function unitCap(serviceTemplate) {
    return serviceSelectors.unitCap({
        cost: serviceTemplate.cost
    });
}
export function isOnApproval(billing) {
    return billing.trigger === BillingTriggerType.OnApproval;
}
export function isOneTimeManual(billing) {
    return billing.trigger === BillingTriggerType.OneTimeManual;
}
export function isOngoing(billing) {
    return billing.trigger === BillingTriggerType.Ongoing;
}
export function isRepeatableManual(billing) {
    return billing.trigger === BillingTriggerType.RepeatableManual;
}
export function isOneTimeInStages(billing) {
    return billing.trigger === BillingTriggerType.OneTimeInStages;
}
export function isOnDemand(billing) {
    return billing.trigger === BillingTriggerType.OnDemand;
}
export function isManual(billing) {
    return isOneTimeManual(billing) || isRepeatableManual(billing) || isOnDemand(billing);
}
export function isRecurring(billing) {
    return isRepeatableManual(billing) || isOngoing(billing);
}
export function matchBilling(billing, matcher) {
    switch(billing.trigger){
        case BillingTriggerType.Ongoing:
            return matcher.ongoing(billing);
        case BillingTriggerType.RepeatableManual:
            return matcher.repeatableManual(billing);
        case BillingTriggerType.OneTimeManual:
            return matcher.oneTimeManual(billing);
        case BillingTriggerType.OneTimeInStages:
            return matcher.oneTimeInStages(billing);
        case BillingTriggerType.OnApproval:
            return matcher.onApproval(billing);
        case BillingTriggerType.OnDemand:
            return matcher.onDemand(billing);
    }
}
export function isBundle(serviceTemplate) {
    return !!serviceTemplate.bundle;
}
export function includedServices(serviceTemplate) {
    return serviceTemplate.bundle ? serviceTemplateBundleSelectors.services(serviceTemplate.bundle) : [];
}
export function formatNumIncludedServices(serviceTemplate, commonTexts) {
    return commonTexts.units.servicesCount({
        count: includedServices(serviceTemplate).length
    });
}
function extendedRecurrencePeriod(serviceTemplate) {
    return matchBilling(serviceTemplate.billing, {
        ongoing: (ongoing)=>ongoing.recurrencePeriod,
        repeatableManual: (repeatableManual)=>repeatableManual.recurrencePeriod,
        oneTimeManual: ()=>'onetime',
        oneTimeInStages: ()=>'inStages',
        onApproval: ()=>'onetime',
        onDemand: ()=>'onDemand'
    });
}
export function formatExtendedRecurrencePeriod(serviceTemplate, isInSentence, texts) {
    return extendedRecurrencePeriodText(extendedRecurrencePeriod(serviceTemplate), isInSentence, texts);
}
